import { render, staticRenderFns } from "./notification-send-modal.vue?vue&type=template&id=3b4e630f&scoped=true"
import script from "./notification-send-modal.vue?vue&type=script&lang=js"
export * from "./notification-send-modal.vue?vue&type=script&lang=js"
import style0 from "./notification-send-modal.vue?vue&type=style&index=0&id=3b4e630f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e630f",
  null
  
)

export default component.exports